import classNames from 'clsx';
import { format } from 'date-fns';
import React, { useState } from 'react';

import EventResultModal from './EventResultModal';
import styles from './Events.scss';

export interface Table {
  events: EventResult[];
  tour?: string;
  stop?: string;
}

export interface EventResult {
  title: string;
  startDate: Date;
  players: string;
  prizePool: string;
  winner: { name: string; prize: string; tableUrl: string };
  orderId: string;
  buyin: string;
}

const EventResultTable: React.FC<Table> = ({ events, tour, stop }) => {
  const [selectedEvent, setSelectedEvent] = useState(-1);

  return (
    <div className={styles.tableContainer}>
      <table className={styles.eventsTable}>
        <thead>
          <tr>
            <th className={styles.optionalData}>#</th>
            <th>Event</th>
            <th className={styles.optionalData}>Players</th>
            <th className={styles.optionalData}>Prize Pool</th>
            <th>Winner</th>
          </tr>
        </thead>
        <tbody>
          {!events.length && (
            <tr>
              <td className={classNames(styles.centerAlign, styles.tableSubHeader)} colSpan={8}>
                No Data
              </td>
            </tr>
          )}
          {events.map((item, i) => (
            <React.Fragment key={i}>
              <tr>
                <td className={styles.optionalData}>{item.orderId}</td>
                <td>
                  <span className={styles.eventTitle} onClick={() => setSelectedEvent(i)}>
                    {item.title}
                  </span>
                  <div className={styles.wideViewData}>
                    {format(new Date(item.startDate), 'yyyy-MM-dd')}
                    <br />
                    {item.buyin}
                  </div>
                  <div className={styles.optionalColumnData}>
                    <strong>Event Number </strong> #{item.orderId}
                    <br />
                    <strong>Date </strong> {format(new Date(item.startDate), 'yyyy-MM-dd')}
                    <br />
                    <strong>Buy-In </strong> {item.buyin}
                    <br />
                    <strong>Prize Pool </strong> {item.prizePool}
                    <br />
                    <strong>Players </strong> {item.players}
                    <br />
                  </div>
                  {i === selectedEvent && (
                    <EventResultModal
                      {...item}
                      tour={tour}
                      stop={stop}
                      winnersUrl={item.winner.tableUrl}
                      onClose={() => setSelectedEvent(-1)}
                    />
                  )}
                </td>
                <td className={styles.optionalData}>{item.players}</td>
                <td className={styles.optionalData}>{item.prizePool}</td>
                <td>
                  <strong>{item.winner.name}</strong>
                  <br />
                  {item.winner.prize}
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EventResultTable;
